import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import * as React from "react";
import { Link, Outlet, useLocation } from "react-router";

import { EntityComments } from "@/shared/components/comments";
import {
  RobotoStyledTab,
  RobotoStyledTabs,
} from "@/shared/components/index.tsx";
import { CollectionRecord } from "@/shared/domain/collections";

import styles from "./CollectionDetails.module.css";
import { CollectionHeader } from "./CollectionHeader";
import {
  CollectionTab,
  useActiveCollectionTab,
} from "./useActiveCollectionTabFromUrl";

interface CollectionDetailsProps {
  collection: CollectionRecord;
}

export const CollectionDetails: React.FC<CollectionDetailsProps> = ({
  collection,
}) => {
  const activeTab = useActiveCollectionTab();
  const location = useLocation();

  return (
    <div className={styles.root}>
      {/* Header + tab bar */}
      <div className={styles.headerSection}>
        <CollectionHeader collection={collection} />

        {/* Tab bar */}
        <div>
          <RobotoStyledTabs value={activeTab}>
            <RobotoStyledTab
              value={CollectionTab.Items}
              label="Items"
              icon={
                <FormatListBulletedOutlinedIcon style={{ fontSize: "1rem" }} />
              }
              iconPosition="start"
              component={Link}
              to={{ pathname: CollectionTab.Items, search: location.search }}
              replace
            />
            <RobotoStyledTab
              value={CollectionTab.Details}
              label="Details"
              icon={<InfoOutlinedIcon style={{ fontSize: "1rem" }} />}
              iconPosition="start"
              component={Link}
              to={{ pathname: CollectionTab.Details, search: location.search }}
              replace
            />
            <RobotoStyledTab
              value={CollectionTab.Activity}
              label="Activity"
              icon={<AccessTimeOutlinedIcon style={{ fontSize: "1rem" }} />}
              iconPosition="start"
              component={Link}
              to={{
                pathname: CollectionTab.Activity,
                search: location.search,
              }}
              replace
            />
            <RobotoStyledTab
              value={CollectionTab.Permissions}
              label="Permissions"
              icon={<ShieldOutlinedIcon style={{ fontSize: "1rem" }} />}
              iconPosition="start"
              component={Link}
              to={{
                pathname: CollectionTab.Permissions,
                search: location.search,
              }}
              replace
            />
          </RobotoStyledTabs>
        </div>
      </div>

      {/* Items tab needs flex-fill + internal scroll so the table fills the
          viewport. Other tabs use plain padding so <EntityComments> sits
          directly under the content rather than being pushed to the bottom. */}
      <div
        className={
          activeTab === CollectionTab.Items
            ? styles.itemsOutlet
            : styles.tabPanel
        }
      >
        <Outlet context={collection} />
      </div>

      <div className={styles.commentsSection}>
        <EntityComments
          entityType="collection"
          entityId={collection.collection_id}
        />
      </div>
    </div>
  );
};
